<template>
  <report-filter-autocomplete-object
  :label="$t(label)"
  v-model="model"
  @input="$emit('selected')"
  item-text="model"
  item-value="id"
  :normal="normal"
  :items="parts"
  :outlined="outlined"
  :loading="loading"
  :placeholder="placeholder"
  :required="required"
  :disabled="disabled"/>
</template>
<script>
import { fetchAllPartsByCategory } from '@/repositories/partRepo'
import { execHttpRequestThrowable } from '@/services/http'
import { getUserIdentification } from '@/services/authService'
import ReportFilterAutocompleteObject from '@/components/report/ReportFilterAutocompleteObject'
export default {
  components: {
    ReportFilterAutocompleteObject
  },
  props: {
    label: {
      type: String,
      default: () => "textFields.partLabel"
    },
    placeholder: String,
    value: Object,
    required: Boolean,
    disabled: Boolean,
    outlined: Boolean,
    category: Object,
    serviceCategory: String,
    normal: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  watch: {
    "$props.category": {
      handler(v) {
        if (v) this.tryToFetchPartsByCategory(v.key)
        else this.parts = []
      }
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    }
  },
  data() {
    return {
      parts: [],
      loading: false
    }
  },
  methods: {
    async tryToFetchPartsByCategory(category) {
      try {
        this.loading = true
        const r = await execHttpRequestThrowable(async () => await fetchAllPartsByCategory(category, getUserIdentification(), [this.serviceCategory]))
        this.parts = r.response.data
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>
<style>

</style>